import type { CMSSectionFullBleedBanner } from '@/types/sanity'
import { Section } from '@/components/Sections/Section'

import styles from './FullBleedBanner.module.scss'
import { ResponsiveImage } from '@/components/Shared/ResponsiveImage'
import type React from 'react'

type SectionFullBleedBanner = {
  content: CMSSectionFullBleedBanner
}

export const FullBleedBanner: React.FC<SectionFullBleedBanner> = ({
  content,
}) => {
  const { _id, eyebrow, header, theme, backgroundImage } = content
  return (
    <Section id={_id} theme={theme} hasWrapper={false} size="zero">
      <div className={styles.container}>
        {eyebrow && <p className={`${styles.eyebrow} type-label`}>{eyebrow}</p>}
        <h1 className={` ${styles.header} type-h3 md:type-h4`}>{header}</h1>
        {backgroundImage && (
          <div className={styles.backgroundImage}>
            <ResponsiveImage
              document={backgroundImage}
              overrides={{
                desktopAspectRatio: 'auto',
                mobileAspectRatio: 'auto',
                loading: 'eager',
                customSizes: [640, 768, 1024, 1200],
              }}
            />
          </div>
        )}
      </div>
    </Section>
  )
}
